import classNames from 'classnames';
import { KYC_VERIFY_ID_ROUTE } from 'consts/routes/urls';
import ArrowRight from 'public/assets/icons/arrow_right.svg';
import CircledBanIcon from 'public/assets/icons/circled_ban.svg';
import { PortfolioType } from 'types/portfolio-types';
import { UrlObject } from 'url';
import classes from './index.module.scss';

export const NOTIFICATION_ITEMS = [
  {
    className: classNames(classes.notification, classes.pressable),
    icon: CircledBanIcon,
    iconClassName: classes.icon,
    title: 'Upload ID',
    titleClassName: classes.title,
    subtitle:
      'By uploading your ID, you will be able to increase your transfer limits.',
    subtitleClassName: classes.subtitle,
    action: 'Upload ID',
    actionClassName: classes.action,
    actionIcon: ArrowRight,
    actionIconClassName: classes.actionIcon,
    onClick: (
      navigate: (
        url: string | UrlObject,
        as?: string | UrlObject | undefined
      ) => void
    ) => {
      navigate(KYC_VERIFY_ID_ROUTE);
    },
    condition: ({ portfolio }: { portfolio?: PortfolioType }) =>
      portfolio?.isDocumentsUploaded === false,
  },
];
